import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ModalHOC } from 'common';
import { ReloadIcon } from 'common/icons';
import { LoginCell, ChallengeInfoElem, ActionsButton, MoneyCell, BasicModal } from 'common/components';

import { getUserChallenges } from 'client/challenges/_redux';
import { staticStyles } from './style';
import { RestartChallengeForm } from '../../../index';

// FIXME: Пытался кастомны джсом но не мог зацепиться, пока так но убрать конечно все что связано с хиро в ближайшем будущем
const isHero =
  document.location.hostname === 'portal.herofx.co' || document.location.hostname === 'herodev.prod.uptr.dev';

const ChallengeHistoryItem = ({ archiveChallenge }) => {
  const [restartModalIsOpen, setRestartModalIsOpen] = useState(false);

  return (
    <div className="ChallengeHistoryItemWrapper">
      <div className="ChallengeHistoryItems--Left">
        <LoginCell noColor title={archiveChallenge.challenge.title} login={archiveChallenge.account?.login} />
        <ChallengeInfoElem>{archiveChallenge.challenge.title}</ChallengeInfoElem>
        <ChallengeInfoElem innerDotColor="blue">{archiveChallenge.level.name}</ChallengeInfoElem>
        <ChallengeInfoElem borderColor="#0AA1E2">
          {archiveChallenge.challenge.initialAccountBalance && (
            <MoneyCell
              style={{ fontWeight: 500 }}
              heightMaxContent
              value={archiveChallenge.challenge.initialAccountBalance}
            />
          )}
        </ChallengeInfoElem>
      </div>

      <div className="ChallengeHistoryItem ChallengeHistoryItem--Right">
        <ActionsButton
          tooltipId="Restart__tooltip"
          tooltipTextId={!isHero ? 'justRestartChallenge' : 'justRestartChallengeHERO10X'}
          deleteType
          disabled={!archiveChallenge.challenge.isAvailable}
          onClickFunc={() => {
            setRestartModalIsOpen(true);
          }}>
          <div className="ReloadIcon">
            <ReloadIcon />
          </div>
        </ActionsButton>
      </div>

      <BasicModal
        captionId={isHero ? 'justRestartChallengeHERO10X' : 'justRestartChallenge'}
        isOpen={restartModalIsOpen}
        onRequestClose={() => setRestartModalIsOpen(false)}>
        <RestartChallengeForm
          challengeId={archiveChallenge.challenge.id}
          challengeCost={archiveChallenge.challenge.cost}
          restartButtonTextId={isHero ? 'justRestartChallengeHERO10X' : 'justRestartChallenge'}
          toggleModal={() => setRestartModalIsOpen(prev => !prev)}
          userChallengesParams={{ search: {} }}
        />
      </BasicModal>

      <style jsx>{staticStyles}</style>
    </div>
  );
};

export default compose(
  ModalHOC,
  connect(null, {
    getUserChallenges: search => getUserChallenges.request(search),
  })
)(ChallengeHistoryItem);
